import React from 'react'
import type { NextPage } from 'next'
import PageHero from '../components/PageHero/PageHero'
import PageBody from '../components/PageBody/PageBody'
import Head from 'next/head'
import InfoBlock from '../components/InfoBlock/InfoBlock'

const Play: NextPage = () => {
    return (
        <>
            <Head>
                <title>Explore the metaverse</title>
            </Head>
            <PageHero image="/images/play.png" title="Explore the metaverse" />
            <PageBody>
                <InfoBlock
                    title="Trade"
                    image="/images/trade_info.jpg"
                    description="Buy and sell assets on the Solice marketplace. The Solice market is a web-based exchange center,
                    however unique to some other projects, we will also be launching the Marketplace within the Solice
                    metaverse where users will be able to see objects in 3D VR, giving potential buyers a more immersive
                    and customer-centric experience."
                />
                <InfoBlock
                    title="Earn"
                    image="/images/earn_info.jpg"
                    description="By clearing dungeons, mini-games and quests or receiving entrance fees for your own creations users may get rewarded with SLC tokens and other rare assets. Users can also earn additional SLC tokens by staking their tokens in the metaverse."
                />
                <InfoBlock
                    title="Create"
                    image="/images/create_info.jpg"
                    description="Solice will be introducing a custom editor which is a SDK that offers users a convenient way to create, assemble, share 3D model assets and build mini-games. We encourage and empower individual creators with intuitive and freedom to create anything. You can make your own 3D assets, animate them, and publish/sell them in our marketplace."
                />
            </PageBody>
        </>
    )
}

export default Play
